$(function() {
  'use strict';
  
  var $svg = $(".svg-container svg");
  var $svg_elements_on = $svg.find("[id$='_on']");
  var $svg_selectors = $(".svg-link");
    
  $svg_selectors.each(function() {
    
    var $svg_selector = $(this);
    var $svg_element_id = $svg_selector.data("layer-id").replace("#", "").replace("_on", "").replace("_off", "");
    var $trigger_style = (typeof $svg_selector.data("trigger-style") !== 'undefined' ? $svg_selector.data("trigger-style") : "both"); //"both", "hover", "click" 

    var $trigger_action = "";
    var $un_trigger_action = "";
    switch ($trigger_style) {
      case "both":
        $trigger_action = "mouseover focus click tap";
        $un_trigger_action = "mouseout";
        break;
      case "click":
        $trigger_action = "click tap";
        break;
      case "hover":
        $trigger_action = "mouseover";
        $un_trigger_action = "mouseout";
        break;   
    }
    
    if($svg.length) {
      var $svg_element_on = $svg.find("#" + $svg_element_id + "_on");
      var $svg_element_off = $svg.find("#" + $svg_element_id + "_off");
      
      $svg_element_off.on($trigger_action, function() {
        $svg_selector.addClass("active");
      });
      
      $svg_element_off.on($un_trigger_action, function() {
        $svg_selector.removeClass("active");
      });
      
      $svg_selector.on($trigger_action, function() {
        $svg_elements_on.hide();
        $svg_element_on.show();
      });
      
      $svg_selector.on($un_trigger_action, function() {
        $svg_element_on.hide();
      });
      
    }
  
  });
  
  
});